/**
 * WashPros Launch Flags
 * Toggle pre-launch behaviors without removing booking code.
 * Override via env: REACT_APP_PUBLIC_BOOKING_ENABLED=false to gate behind waitlist.
 */
const truthy = (v, defaultValue = true) => {
  const s = String(v ?? "").toLowerCase();
  if (s === "") return defaultValue;
  return s === "true" || s === "1";
};

// Customer booking is LIVE by default. Set REACT_APP_PUBLIC_BOOKING_ENABLED=false
// to flip the homepage + /book routes to the waitlist landing page.
export const PUBLIC_BOOKING_ENABLED = truthy(
  process.env.REACT_APP_PUBLIC_BOOKING_ENABLED,
  true
);

export const PUBLIC_VIP_ENABLED = truthy(
  process.env.REACT_APP_PUBLIC_VIP_ENABLED,
  true
);

export const VENDOR_ONBOARDING_ENABLED = truthy(
  process.env.REACT_APP_VENDOR_ONBOARDING_ENABLED,
  true
);

// First-Wash $5-off promo banner on customer dashboard.
// Shown only to accounts < 24h old with zero prior completed bookings.
// Discount is platform-subsidised (comes from WashPros commission;
// vendor payout untouched). One-shot per account, $30 minimum
// subtotal, cannot stack with VIP / referral / other promos.
// Set REACT_APP_FIRST_WASH_PROMO_ENABLED=false to flip OFF.
export const FIRST_WASH_PROMO_ENABLED = truthy(
  process.env.REACT_APP_FIRST_WASH_PROMO_ENABLED,
  true
);


// ──────────────────────── Auth feature flags ────────────────────────

// Phone-number login (Continue with phone → OTP).  DEFAULT OFF until
// the Twilio A2P 10DLC campaign is VERIFIED.  When this flag is false
// OR the backend reports A2P pending, the UI shows:
//   "Phone login is almost ready. Use email login for now."
// Flip true ONLY after Rick explicitly approves post-A2P-verification.
export const PHONE_LOGIN_ENABLED = truthy(
  process.env.REACT_APP_PHONE_LOGIN_ENABLED,
  false
);

// "Keep me logged in" — checked = long-session persistent storage;
// unchecked = session-only storage that clears when the tab/window
// closes.  The visible default is checked (matches user expectation
// after they've explicitly typed a password — they don't want to
// re-login next visit).
export const KEEP_ME_LOGGED_IN_DEFAULT = truthy(
  process.env.REACT_APP_KEEP_ME_LOGGED_IN_DEFAULT,
  true
);

// Passkeys / WebAuthn — "Sign in with Face ID / Touch ID / Windows Hello".
// DEFAULT OFF.  Infrastructure is built behind this flag so QA can flip
// it on later without a code release.  The backend also enforces its
// own PASSKEYS_ENABLED env var — the frontend just hides the surface.
export const PASSKEYS_ENABLED = truthy(
  process.env.REACT_APP_PASSKEYS_ENABLED,
  false
);

